import { FieldProps } from 'formik';
import * as React from 'react';
import { string } from 'yup';
import ErrorTextField from './ErrorTextField';

interface FormFieldProps extends FieldProps {
	required?: boolean;
}

const Address: React.StatelessComponent<FormFieldProps> = function (props) {
	const {
		form: { errors, touched },
		field,
		required,
	} = props;
	const name = field.name;

	return <ErrorTextField
		errorMessage={touched[name] ? errors[name] as string : undefined}
		label='Address'
		required={required}
		{...field}
	/>;
};

export function addressValidation (required: boolean = false) {
	const value = string();

	if (required) {
		return value.required('Please enter your address.');
	}

	return value;
}

export default Address;
